import { Image } from './Image';

export function Logo({ size = 40, ...props }) {
  return (
    <Image
      src="/assets/terrakite-logo.png"
      alt="TerraKite Logo"
      width={size}
      height={size}
      style={{ display: 'block' }}
      {...props}
    />
  );
}
